// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import BusinessHeroImg from "../../asset/Accounting.png";   // Hero background image (replace if needed)
// import BusinessCenterImg from "../../asset/image1.png";     // Center image for Business Advisory
// import BusinessRightImg from "../../asset/image8.png";      // Right-side image for services section
// import LineImg from "../../asset/line1.png";                // Line image
// import pointImg from "../../asset/point.png";               // Icon for points
// import "./ServiceBusiness.css";                          // Create or reuse existing CSS

// const ServiceBusiness = () => {
//   return (
//     <div>
//       {/* Hero Section */}
// <div
//   className="services-hero"
//   style={{
//     backgroundImage: `url(${BusinessHeroImg})`,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     height: "88vh",
//     position: "relative",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//   }}
// >
//   {/* Dark Overlay */}
//   <div className="services-overlay"></div>

//   {/* Hero Content */}
//   <div className="services-content">
//     <h1 className="services-heading">Building Trust Through Transparency</h1>
//     <p className="services-paragraph">
//       We deliver through audits and assurance services that enhance credibility,
//       accuracy and confidence for your stakeholders.
//     </p>
//   </div>
// </div>


//       {/* Business Advisory Image Section */}
//       <div className="detail-section">
//         <Container className="text-center">
//           <div className="d-flex align-items-center justify-content-center flex-wrap">
//             <img src={LineImg} alt="line-left" className="side-line" />

//             <div className="center-image-wrapper">
//               {/* <img
//                 src={BusinessCenterImg}
//                 alt="Business Advisory Services"
//                 className="side-image"
//               /> */}
//               <div className="image-text">Business Start-up & Support</div>
//             </div>

//             <img src={LineImg} alt="line-right" className="side-line mirrored" />
//           </div>
//         </Container>
//       </div>

//       {/* Service Points Section */}
//       <div className="service-image-section">
//         <Container>
//           <Row className="align-items-center">
//             {/* Left Column with Points */}
//             <Col md={6}>
//               <ul className="service-points">
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Incorporation of Companies
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Obtaining Licenses & Registrations
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Bookkepping & Accounting
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Payroll Management
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Recruitment Support
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Real Estate Support
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Management Accounting
//                 </li>
//                  <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Reporting to Parent Companies
//                 </li>
//                  <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Assistance in Company Secretarial Matters
//                 </li>
//               </ul>
//             </Col>

//             {/* Right Column with Image */}
//             <Col md={6} className="text-center text-md-end">
//               <img
//                 src={BusinessRightImg}
//                 alt="Business Advisory Detail"
//                 className="service-right-image"
//               />
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </div>
//   );
// };

// export default ServiceBusiness;
import React, { memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import BusinessRightImg from "../../asset/startup.webp"; // Right-side image
import LineImg from "../../asset/line1.png";           // Line image
import BusinessImg from "../../asset/Accounting.webp"; 
import pointImg from "../../asset/point.png";         // Icon for points
import "./ServiceBusiness.css";

// ✅ Memoized service point component
const ServicePoint = memo(({ text }) => (
  <li>
    <img src={pointImg} alt="icon" className="point-icon" loading="lazy" />
    {text}
  </li>
));

const ServiceBusiness = () => {
  const servicePoints = [
    "Incorporation of Companies",
    "Obtaining Licenses & Registrations",
    "Bookkeeping & Accounting",
    "Payroll Management",
    "Recruitment Support",
    "Real Estate Support",
    "Management Accounting",
    "Reporting to Parent Companies",
    "Assistance in Company Secretarial Matters",
  ];

  return (
    <div>
      {/* Hero Section */}
      <div className="services-hero business-hero"
       style={{
    backgroundImage: `url(${ BusinessImg})`, // ✅ Use template literal with imported image
  }}
      >
        <div className="services-overlay"></div>
        <div className="services-content">
          <h1 className="services-heading">Building Trust Through Transparency</h1>
          <p className="services-paragraph">
            We deliver through business advisory services that enhance credibility,
            accuracy, and confidence for your stakeholders.
          </p>
        </div>
      </div>

      {/* Business Advisory Center Section */}
      <div className="detail-section">
        <Container className="text-center">
          <div className="d-flex align-items-center justify-content-center flex-wrap">
            <img src={LineImg} alt="line-left" className="side-line" loading="lazy" />
            <div className="center-image-wrapper">
              <div className="image-text">Business Start-up & Support</div>
            </div>
            <img src={LineImg} alt="line-right" className="side-line mirrored" loading="lazy" />
          </div>
        </Container>
      </div>

      {/* Service Points Section */}
      <div className="service-image-section">
        <Container>
          <Row className="align-items-center">
            {/* Left Column with Points */}
            <Col md={6}>
              <ul className="service-points">
                {servicePoints.map((point, index) => (
                  <ServicePoint key={index} text={point} />
                ))}
              </ul>
            </Col>

            {/* Right Column with Image */}
            <Col md={6} className="text-center text-md-end">
              <img
                src={BusinessRightImg}
                alt="Business Advisory Detail"
                className="service-right-image"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default memo(ServiceBusiness);
